module.exports = __webpack_public_path__ + "static/media/account_detail_icon.6bb277be.svg";